/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { inject } from '@angular/core';
import { ZoomInCommand } from './zoom-in.command';
import { MapInteractionsService } from '../../services/mapInteractions.service';

export function zoomInFactory() {
    const command = new ZoomInCommand();
    command.setDependencies({
        interactions: inject(MapInteractionsService)
    });
    return command;
}
